module.exports = __webpack_public_path__ + "img/Picture5.513f4d21.jpg";